import { useEffect, useRef } from 'react'

const useWindowSize = () => {
  const windowSizeRef = useRef({
    width: window.innerWidth,
    height: window.innerHeight,
  })

  useEffect(() => {
    function handleResize() {
      windowSizeRef.current = {
        width: window.innerWidth,
        height: window.innerHeight,
      }
    }
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return windowSizeRef.current
}

export default useWindowSize

